module.exports = "/packs/media/images/SmilingFaces-0d2f630cfcb3f971662b1d6c17059b7c.png";